import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { getCctvsActive } from "./axios/cctvAxios";

const CCTVButtons = ({selectedStream, onSelect, initDefaultImage}) => {
    const [cctvs, setCctvs] = useState([]);

    useEffect(() => {
        // 1. 컴포넌트 마운트 시 CCTV 목록 가져오기
        const fetchCctvs = async () => {
            try {
                getCctvsActive().then((res)=>{
                    setCctvs(res);
                }).catch((err)=>{
                    console.error('CCTV 목록 로드 실패:', err);
                })
            } catch (error) {
                console.error('CCTV 목록 로드 실패:', error);
            }
        };
        fetchCctvs();

        // 주기적으로 상태 업데이트 (선택 사항, 웹소켓이 더 효율적)
        const intervalId = setInterval(fetchCctvs, 10000); // 10초마다 상태 업데이트
        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="vr_btn">
            {cctvs && cctvs.map((stream) => (
                <Button
                key={stream.id}
                color="primary"
                variant="contained" style={{minWidth:"unset",color:"#fff", marginRight:"4px" ,padding:"3px 10px", backgroundColor: selectedStream === stream.name ? 'blueviolet' : ''}} 
                onClick={() => {initDefaultImage(); onSelect(stream.name); }}
                >
                CCTV {stream.name}
                </Button>
            ))}
        </div>
    )
}

export default CCTVButtons;